import { render } from "./AuthHeader.vue?vue&type=template&id=164d3b9d"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"
script.render = render

export default script